import React from "react"
import Images from "../../commonComponents/Images/Images"

const DigidocUnique = () => {

    const whyUnique = [
        {
            img: Images.digidocUnique1,
            content: 'Stay on top of medicines and tests effortlessly with automated schedules and reminders.',
        },
        {
            img: Images.digidocUnique2,
            content: 'Log your medicines and home test readings instantly.',
        },
        {
            img: Images.digidocUnique3,
            content: 'Actionable insights highlight patterns to help improve consistency.',
        },
        {
            img: Images.digidocUnique4,
            content: 'Access anywhere, anytime on your phone for care on the go.',
        },
        {
            img: Images.digidocUnique5,
            content: 'Supports multiple local languages to make health tracking easy for everyone.',
        },
        {
            img: Images.digidocUnique6,
            content: 'Tailored to your lifestyle, ensuring care fits naturally into daily routines.',
        }
    ]


    return (
        // what makes digidoc unique section
        <>
            <section>
                <div className="mxy-40 digidoc-unique-section container">
                    <h4>What makes DigiDoc Unique?</h4>
                    <div className="row row-25 py-20">
                        {whyUnique.map((obj, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
                                <div className="card">
                                    <div className="card-body">
                                        <div className="img-div my-20">
                                            <img src={obj.img} alt={`Unique feature ${index + 1}`} className="img-fluid" />
                                        </div>
                                        <p className="text-center">{obj.content}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}
export default DigidocUnique